import Repository from "./Repository";
const resource = "/api/v1/taxonomy/getValues/";
const sortedResource = "/api/v1/taxonomy/getSortedValues/";
export default {
  getTaxonomyValues(val) {
    let subUrl = `${resource}${val}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getSortedTaxonomyValues(val) {
    let subUrl = `${sortedResource}${val}`;
    return Repository.sendReq({ method: "get", subUrl });
  }
};
